var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
export function validate(form) {
    var e_1, _a;
    try {
        for (var _b = __values(Object.keys(form.controls)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var controlKey = _c.value;
            var control = form.controls[controlKey];
            control.markAsTouched();
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
